/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BillingRawUsageStateEnum = 'DOWNLOADED' | 'PROCESSED' | 'UPLOADED' | 'FAILED' | 'ERROR' | 'SKIPPED';

export const BillingRawUsageStateEnum = {

    DOWNLOADED: 'DOWNLOADED' as BillingRawUsageStateEnum,

    PROCESSED: 'PROCESSED' as BillingRawUsageStateEnum,

    UPLOADED: 'UPLOADED' as BillingRawUsageStateEnum,

    FAILED: 'FAILED' as BillingRawUsageStateEnum,

    ERROR: 'ERROR' as BillingRawUsageStateEnum,

    SKIPPED: 'SKIPPED' as BillingRawUsageStateEnum
};

